// extracted by mini-css-extract-plugin
export default {"wrapper":"graph_wrapper__Pw+ic"};